import { useLocale, useMessages } from '@/i18n/LocaleProvider';
import { messages, type Messages } from '@/i18n/catalogs/editorial/videos-section';

import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Play, Youtube } from 'lucide-react';
import VideoPlayer from './VideoPlayer';
import LiteYouTube from './LiteYouTube';
import SectionHeading from '@/components/SectionHeading';

const getItems = (m: Messages) => [
  {
    title: m.m000,
    description: m.m001,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: 'LiAKzVLbIyw',
    url: 'https://www.youtube.com/watch?v=LiAKzVLbIyw'
  },
  {
    title: m.m002,
    description: m.m003,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: '0FLFhRJlIWU',
    url: 'https://youtu.be/0FLFhRJlIWU'
  },
  {
    title: m.m004,
    description: m.m005,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: '34TtW5Of-Bk',
    url: 'https://www.youtube.com/watch?v=34TtW5Of-Bk'
  },
  {
    title: m.m006,
    description: m.m007,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: 'NU8VuQtX0gw',
    url: 'https://www.youtube.com/watch?v=NU8VuQtX0gw'
  },
  {
    title: m.m008,
    description: m.m009,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: 'xlvjN_eFJvM',
    url: 'https://www.youtube.com/watch?v=xlvjN_eFJvM'
  },
  {
    title: m.m010,
    description: m.m011,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: '7vYMJ9pGfts',
    url: 'https://youtu.be/7vYMJ9pGfts'
  },
  {
    title: m.m012,
    description: m.m013,
    thumbnail: 'https://images.unsplash.com/photo-1487058792275-0ad4aaf24ca7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: 'QSlE6FWlAaM',
    url: 'https://youtu.be/QSlE6FWlAaM'
  },
  {
    title: m.m014,
    description: m.m015,
    thumbnail: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80',
    youtubeId: 'bYmFd8KBuE4',
    url: 'https://youtu.be/bYmFd8KBuE4'
  }
];

const VideosSection = () => {
  const m = useMessages(messages);
  const videos = getItems(m);
  const { locale, formatLocale } = useLocale();
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  const handleVideoClick = (youtubeId: string) => {
    setActiveVideo(youtubeId);
  };

  return (
    <section className="section-padding bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <SectionHeading withId anchor="videos" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {m.m016}{' '}</SectionHeading>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {m.m017}{' '}</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {videos.map((video, index) => (
            <Card key={index} className="overflow-hidden">
              <CardHeader className="pb-0">
                <CardTitle>{video.title}</CardTitle>
                <CardDescription>{video.description}</CardDescription>
              </CardHeader>
              <CardContent className="pt-6">
                <LiteYouTube
                  videoId={video.youtubeId}
                  title={video.title}
                  className="aspect-video w-full rounded-md"
                />
              </CardContent>
              <CardFooter>
                <Button variant="outline" className="w-full" onClick={() => window.open(video.url, '_blank')}>
                  <Youtube className="mr-2" size={16} />
                  {m.m018}{' '}</Button>
              </CardFooter>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideosSection;